import * as React from 'react'
import { FC } from 'react'
import { LocationsPopoverContent } from './LocationsPopoverContent'
import { SelectedLocationsPopoverContentProps } from '../../typings'

export const SelectedLocationsPopoverContentWrapper: FC<
  SelectedLocationsPopoverContentProps
> = (props) => {
  return (
    <LocationsPopoverContent
      displayMatch={false}
      error={false}
      loading={false}
      {...props}
    />
  )
}
SelectedLocationsPopoverContentWrapper.displayName =
  'SelectedLocationsPopoverContentWrapper'
